import { initializeApp } from 'firebase/app';
import {
  connectAuthEmulator,
  FacebookAuthProvider,
  getAuth,
  GithubAuthProvider,
  GoogleAuthProvider,
  TwitterAuthProvider,
} from 'firebase/auth';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { initializeFirestore, serverTimestamp,Timestamp } from 'firebase/firestore';
import { connectFunctionsEmulator,getFunctions } from 'firebase/functions';
import { getRemoteConfig } from 'firebase/remote-config';
import { connectStorageEmulator,getStorage } from 'firebase/storage';

import firebaseConfigFile from './config.json';

const firebaseConfig = firebaseConfigFile.result.sdkConfig;

export const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const googleAuthProvider = new GoogleAuthProvider();
const facebookAuthProvider = new FacebookAuthProvider();
const githubAuthProvider = new GithubAuthProvider();
const twitterAuthProvider = new TwitterAuthProvider();

const storage = getStorage();
const database = getDatabase();
const functions = getFunctions();

let settings = { ignoreUndefinedProperties: true };

// REMOTE CONFIG
const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis = 3600;
remoteConfig.defaultConfig = {
  time_tracker: '{"orgsAllowed":[]}',
  location_alerts_view: '{}',
  emergencies_module: '{}',
  worker_score_module: '{}',
  cost_centers_module: '{}',
};

if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, `http://${window.location.hostname}:9099`);
  connectStorageEmulator(storage, window.location.hostname, 9199);
  connectFunctionsEmulator(functions, window.location.hostname, 5001);
  connectDatabaseEmulator(database, window.location.hostname, 9000);

  settings = {
    ...settings,
    host: `${window.location.hostname}:8080`,
    ssl: false,
  };
}
const db = initializeFirestore(firebaseApp, settings);
export {
  auth,
  database,
  // end of wieldy's
  db,
  facebookAuthProvider,
  functions,
  githubAuthProvider,
  googleAuthProvider,
  remoteConfig,
  serverTimestamp,
  storage,
  Timestamp,
  twitterAuthProvider,
};
